import { merge } from 'rxjs';
import { filter, mergeMap, tap } from 'rxjs/operators';

import { RootEpic } from '../../store/epics';
import { push, replace } from '../reducers';

const navigateEpic: RootEpic = (action$, _state$, { router }) => {
  const push$ = action$.pipe(
    filter(push.match),
    tap(({ payload: path }) => {
      void router.navigate(path);
    }),
  );

  const replace$ = action$.pipe(
    filter(replace.match),
    tap(({ payload: path }) => {
      void router.navigate(path, { replace: true });
    }),
  );

  return merge(push$, replace$).pipe(mergeMap(() => []));
};

export { navigateEpic };
